export default "__VITE_ASSET__BzvmGIfS__"